import { Suspense, lazy } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { PublicRoute } from 'routing/components'
import { AuthDecorator } from 'modules/Auth/components'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const LoginRoute = lazy(
  () => import(/* webpackChunkName: "Login" */ 'modules/Auth/pages/Login')
)

export const ForgotPasswordRoute = lazy(
  () => import(/* webpackChunkName: "ForgotPassword" */ 'modules/Auth/pages/ForgotPassword')
)

export const SetupPasswordRoute = lazy(
  () => import(/* webpackChunkName: "SetupPassword" */ 'modules/Auth/pages/SetupPassword')
)

export const ChangePasswordRoute = lazy(
  () => import(/* webpackChunkName: "ChangePassword" */ 'modules/Auth/pages/ChangePassword')
)

export const RegistrationRoute = lazy(
  () => import(/* webpackChunkName: "Registration" */ 'modules/Auth/pages/Registration')
)

const AuthRouting = () => (
  <AuthDecorator animated>
    <Suspense fallback={<RouteChangeProgress color='white' />}>
      <Switch>
        <PublicRoute exact path={routes.login} component={LoginRoute} restricted />
        <PublicRoute exact path={routes.forgot} component={ForgotPasswordRoute} restricted />
        <PublicRoute exact path={routes.setup} component={SetupPasswordRoute} restricted />
        <PublicRoute exact path={routes.change} component={ChangePasswordRoute} restricted />
        <PublicRoute exact path={routes.registration} component={RegistrationRoute} restricted />
        <Redirect path='*' to={routes.login} />
      </Switch>
    </Suspense>
  </AuthDecorator>
)

export default AuthRouting
